

function ObjectHistoryController ($scope, Object, FormService) {

	var self = this;
	this.versions = [];     // object versions
	this.changesets = [];   // object diffs
	this.is_busy = true;
	this.message = null;
	
	
	this.loadHistory = function() {
		self.versions.length = 0;
		self.changesets.length = 0;
		self.is_busy = true;
		return Object.history().catch(function(error){	
			console.debug('Loading history failed.');
			self.is_busy = false;
			self.message = {type:'danger', body: error.data.message}
			if (error.data.code == 1) {
				self.message.type='warning';
			}
			return $q.reject(error);
		}).then(function(versions){
			self.is_busy = false;
			versions = versions.sort(function(a, b) {  // reverse
			    return - (a.effective_time.from > b.effective_time.from? 1 : (a.effective_time.from < b.effective_time.from? -1 : 0) );
			})
			self.versions = versions;
			self.changesets = self.makeChangesets(versions);
		});
	}
	
	this.loadHistory();
	$scope.$on('object-reload', function(){
		self.loadHistory();
	});
	
	this.makeChangesets = function(versions) {
		var changesets = [];
		for (var i=0; i<versions.length; i++) {
			
			var changeset = {
				base: i+1<versions.length && versions[i+1].__id == versions[i].__id? versions[i+1] : null,
				changed: versions[i],
				type: null,
				changes: [],
				date: versions[i].effective_time.from,
				days: null,
				author: versions[i].editor_login,
			};

			var workflow = this.compareObjects(changeset.base, changeset.changed, ['workflow', 'workflow-top']);
			[].push.apply(changeset.changes, workflow);

			if (changeset.base == null) {
				changeset.type = 'create';
			} else if (workflow.length > 0) {
				changeset.type = 'workflow';
			} else if (changeset.changed.deleted && !changeset.base.deleted) {
				changeset.type = 'delete';
			} else {
				changeset.type = 'edit';
			}
			if (versions[i].couch_uuid && versions[i].winning_rev == false) {
				changeset.type = 'conflict'
				changeset.base = null;
			}
			
			var edits = this.compareObjects(changeset.base, changeset.changed, ['edit', 'clone', 'edit-ext']);
			[].push.apply(changeset.changes, edits);
			

			if (changeset.changed.effective_time) {
				var days = moment().diff(moment(changeset.changed.effective_time.from), 'days');
				changeset.days = days;
			}
			if (changeset.changes.length || changeset.type != 'edit') {
				changesets.push(changeset);
			}
		}
		// is this needed?
		changesets.sort(function(a, b) { 
		    return - (a.changed.effective_time.from.localeCompare(b.changed.effective_time.from));
		});
		return changesets;
	}
	
	this.compareObjects = function(base, changed, group) {
		var changes = [];
		base = base || {};
		var cls = changed.getClass();
		var fields = cls.get_fields(group);
		
				
		for (var i in fields) {
			var field = fields[i];
			var property = field.name;
			var from = base[property];
			var to = changed[property];
			if (field.type == 'ReferenceField' ) {
				//from = from? from.__title : null;
				//to = to? to.__title : null;
				from = from? from.__id : null;
				to = to? to.__id : null;
			} else if (field.type == 'GridReferenceField' || field.type == 'BackReferenceField') {
				var obj2str = function(obj) {
					if (!obj) return "";
					var out = {};
					var cls = obj.getClass();
					var fields = cls.get_fields('edit');
					for (var i in fields) {
						if (typeof obj[fields[i].name] != "object") {
							out[fields[i].name] = obj[fields[i].name];
						} else if (obj[fields[i].name] && obj[fields[i].name].__id) {
							out[fields[i].name] = obj[fields[i].name].__id;
						}
						
					}
					return angular.toJson(out);
				}
				from = ""+ angular.toJson(_.map(from, obj2str));
				to = ""+ angular.toJson(_.map(to, obj2str));
			} else if (_.isObject(changed[property])) {
				from = angular.toJson(from);
				to = angular.toJson(to);
			} else if (_.isArray(changed[property])) {
				from = angular.toJson(from);
				to = angular.toJson(to);
			} else if (field.type == 'Field' || field.type == 'TextField') {
				if (from && from != to) {
					to = diffString(from || "", to || "");
				}
			}
			//console.debug(property, base[property] , changed[property]);
	        if (from != to) {
	        	var change = {};
	        	change.name = property;
	        	change.title = field.title;
	        	change.from = from;
	        	change.to = to;
	        	change.field = field;
	        	change.base = base[property];
	        	change.changed = changed[property];
	        	changes.push(change);
	        }			
		}
		return changes;
	}


	this.object_activate_form = function(object, form, formdata) {
		if (typeof form == 'string') {
			form = object.get_form(form);
		}
		return FormService.activateFormModal(form, formdata);
	}

	
	window.historyCtrl = this;
}


angular.module('admin')
.controller('ObjectHistoryController', ObjectHistoryController)

/*
 * Javascript Diff Algorithm
 *  By John Resig (http://ejohn.org/)
 *  Modified by Chu Alan "sprite"
 *
 * Released under the MIT license.
 *
 * More Info:
 *  http://ejohn.org/projects/javascript-diff-algorithm/
 */

function escape(s) {
    var n = s;
    n = n.replace(/&/g, "&amp;");
    n = n.replace(/</g, "&lt;");
    n = n.replace(/>/g, "&gt;");
    n = n.replace(/"/g, "&quot;");

    return n;
}

function diffString( o, n ) {
  o = o.replace(/\s+$/, '');
  n = n.replace(/\s+$/, '');

  var out = diff(o == "" ? [] : o.split(/\s+/), n == "" ? [] : n.split(/\s+/) );
  var str = "";

  var oSpace = o.match(/\s+/g);
  if (oSpace == null) {
    oSpace = ["\n"];
  } else {
    oSpace.push("\n");
  }
  var nSpace = n.match(/\s+/g);
  if (nSpace == null) {
    nSpace = ["\n"];
  } else {
    nSpace.push("\n");
  }

  if (out.n.length == 0) {
      for (var i = 0; i < out.o.length; i++) {
        str += '<del>' + escape(out.o[i]) + oSpace[i] + "</del>";
      }
  } else {
    if (out.n[0].text == null) {
      for (n = 0; n < out.o.length && out.o[n].text == null; n++) {
        str += '<del>' + escape(out.o[n]) + oSpace[n] + "</del>";
      }
    }

    for ( var i = 0; i < out.n.length; i++ ) {
      if (out.n[i].text == null) {
        str += '<ins>' + escape(out.n[i]) + nSpace[i] + "</ins>";
      } else {
        var pre = "";

        for (n = out.n[i].row + 1; n < out.o.length && out.o[n].text == null; n++ ) {
          pre += '<del>' + escape(out.o[n]) + oSpace[n] + "</del>";
        }
        str += " " + out.n[i].text + nSpace[i] + pre;
      }
    }
  }
  
  return str;
}


function diff( o, n ) {
  var ns = new Object();
  var os = new Object();
  
  for ( var i = 0; i < n.length; i++ ) {
    if ( ns[ n[i] ] == null )
      ns[ n[i] ] = { rows: new Array(), o: null };
    ns[ n[i] ].rows.push( i );
  }
  
  for ( var i = 0; i < o.length; i++ ) {
    if ( os[ o[i] ] == null )
      os[ o[i] ] = { rows: new Array(), n: null };
    os[ o[i] ].rows.push( i );
  }
  
  for ( var i in ns ) {
    if ( ns[i].rows.length == 1 && typeof(os[i]) != "undefined" && os[i].rows.length == 1 ) {
      n[ ns[i].rows[0] ] = { text: n[ ns[i].rows[0] ], row: os[i].rows[0] };
      o[ os[i].rows[0] ] = { text: o[ os[i].rows[0] ], row: ns[i].rows[0] };
    }
  }
  
  for ( var i = 0; i < n.length - 1; i++ ) {
    if ( n[i].text != null && n[i+1].text == null && n[i].row + 1 < o.length && o[ n[i].row + 1 ].text == null && 
         n[i+1] == o[ n[i].row + 1 ] ) {
      n[i+1] = { text: n[i+1], row: n[i].row + 1 };
      o[n[i].row+1] = { text: o[n[i].row+1], row: i + 1 };
    }
  }
  
  for ( var i = n.length - 1; i > 0; i-- ) {
    if ( n[i].text != null && n[i-1].text == null && n[i].row > 0 && o[ n[i].row - 1 ].text == null && 
         n[i-1] == o[ n[i].row - 1 ] ) {
      n[i-1] = { text: n[i-1], row: n[i].row - 1 };
      o[n[i].row-1] = { text: o[n[i].row-1], row: i - 1 };
    }
  }
  
  return { o: o, n: n };
}

